module.exports = __webpack_public_path__ + "static/key-huntsman-39f1e70a66c04ab4ab842981824e6a5d.webp";